<template>
  <div width="100%">
    <v-row class="voicemail-settings-transcription ma-0">
      <v-card outlined class="mb-4 pa-4" width="100%">
        <v-switch dense :disabled="!canWrite || hasMultipleActiveWatchers" data-testid="voicemails-settings-ia-transcript" v-model="transcript"
          :label="$t('vmail.cfg.settings.transcript')">
          <template v-slot:prepend>
            <v-icon>mdi-text-box</v-icon>
          </template>
          <template v-slot:append>
            <cp-help i18n="vm.transcript" />
          </template>
        </v-switch>
        <v-checkbox v-if="transcript" dense :disabled="!canWrite || hasMultipleActiveWatchers" class="vmb-transcript ml-8" v-model="summarize"
          :label="$t('vmail.cfg.settings.summarize')">
        </v-checkbox>
        <v-checkbox v-if="transcript" dense :disabled="!canWrite || hasMultipleActiveWatchers" class="vmb-transcript ml-8" v-model="categorize"
          :label="$t('vmail.cfg.settings.categorize')">
        </v-checkbox>
      </v-card>
    </v-row>
    <v-row class="voicemail-settings-translation ma-0" v-if="transcriptionEnabled">
      <v-card outlined class="pa-4" width="100%">
        <v-switch dense :disabled="!transcriptionEnabled" data-testid="voicemails-settings-ia-translate" v-model="translate"
          :label="$t('vmail.cfg.settings.translate')">
          <template v-slot:prepend>
            <v-icon>mdi-translate</v-icon>
          </template>
          <template v-slot:append>
            <cp-help i18n="vm.translate" />
          </template>
        </v-switch>
        <v-autocomplete
          v-if="translate"
          class="ml-8"
          data-testid="voicemails-settings-ia-translate-language"
          v-model="translationLanguage"
          :items="translationLanguages"
          item-text="name"
          item-value="code"
          outlined
          dense
          small-chips
          label="Language"
        />
      </v-card>
    </v-row>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
const ISO6391 = require('iso-639-1')

export default {
  name: 'voicemail-settings-general-transcription',
  computed: {
    ...mapGetters({
      vmbox: 'voicemails/vmboxSettings',
      currentUserID: 'settings/userID',
      vmboxWriteFor: 'permissions/vmboxWriteFor',
      canWriteCurrentUser: 'permissions/vmboxesWrite',
      vmWatcherBoxID: 'voicemails/watcherBoxID',
      vmWatcherSubscriberID: 'voicemails/watcherSubscriberID',
      vmWatcherUserID: 'voicemails/watcherUserID',
      activeWatchers: 'voicemails/activeWatchers'
    }),
    canWrite: function () {
      if (this.activeWatchers.length > 1) {
        return false
      }
      if (this.currentUserID === this.vmWatcherUserID) {
        return this.canWriteCurrentUser
      }
      return this.vmboxWriteFor(this.vmWatcherSubscriberID)
    },
    hasMultipleActiveWatchers: function () {
      return this.activeWatchers.length > 1
    },
    translationLanguages () {
      return ISO6391?.getAllCodes().map(code => ({
        name: ISO6391.getNativeName(code),
        code: code
      }))
    },
    transcriptionEnabled () {
      return this.canWrite && this.transcript
    },
    transcript: {
      get: function () {
        return this.vmbox.transcript
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.summarize) {
          this.setTranscript(value)
          this.setSummarize(value)
          this.setCategorize(value)
          if (!value) {
            this.setTranslate(false)
          }
          this.save()
        }
      }
    },
    summarize: {
      get: function () {
        return this.vmbox.summarize
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.summarize) {
          this.setSummarize(value)
          this.save()
        }
      }
    },
    categorize: {
      get: function () {
        return this.vmbox.categorize
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.transcript) {
          this.setCategorize(value)
          this.save()
        }
      }
    },
    translate: {
      get: function () {
        return this.vmbox.translate
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.translate) {
          this.setTranslate(value)
          this.save()
        }
      }
    },
    translationLanguage: {
      get: function () {
        return this.vmbox.translationLanguage
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.translationLanguage) {
          this.setTranslateLanguage(value)
          this.save()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setTranscript: 'voicemails/setVBTranscript',
      setSummarize: 'voicemails/setVBSummarize',
      setCategorize: 'voicemails/setVBCategorize',
      setTranslate: 'voicemails/setVBTranslate',
      setTranslateLanguage: 'voicemails/setVBTranslationLanguage',
      save: 'voicemails/saveSettings'
    })
  }
}
</script>

<style scoped>
</style>
